const API_ROUTES = Object.freeze({
  LOGIN: "/api/login/",
  REFRESH: "/api/token/refresh/",
  ACCEPT_INVITE: "/api/accept-invite/",
  FORGOT_PASSWORD: "/api/forgot-password/",
  USER_ME: "/users/me/",
  USER_ORGANIZATION: "/users/organizations/",
});

const QUERY_KEYS = Object.freeze({
  USER_ME: "user",
  USER_ORGANIZATION: "user-organizations",
})

export { API_ROUTES, QUERY_KEYS };
